export interface ArticleDto {
  idArticle: number;
  codeArticle: string;
  libelleArticle: string;
  codeEan?: string;
  hasSubReferences?: boolean;
  idFamille?: number;
  libelleFamille?: string;
  idSousFamille?: number;
  libelleSousFamille?: string;
  prixAchat?: number;
}

export interface ArticleSousReferenceDto {
  idArticleSousReference: number;
  idArticle: number;
  codeArticle: string;
  libelleArticle: string;
  libelleSousReference: string;
  codeEan?: string;
  tableBase?: string;
  idFamille?: number;
  libelleFamille?: string;
  idSousFamille?: number;
  libelleSousFamille?: string;
  prixAchat?: number;
}

export type ArticleResponse = ArticleDto | ArticleSousReferenceDto;

export function isSubReference(article: ArticleResponse): article is ArticleSousReferenceDto {
  return 'idArticleSousReference' in article;
}
